/**
 * Master-Detail Plugin Styles
 *
 * Scoped to tbw-grid using CSS nesting for light DOM compatibility.
 */
@layer tbw-plugins {
  tbw-grid {
    /* Expander column data cells - always first, borderless right edge */
    & .cell[data-field='__tbw_expander'] {
      border-right: none !important;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /* Expander column header - completely hidden; the next column's grid-column
       span is set dynamically by afterRender to cover the expander's track. */
    & .header-row .cell[data-field='__tbw_expander'] {
      display: none;
    }

    /* Master-detail expander cell */
    .master-detail-expander {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    .master-detail-toggle {
      cursor: pointer;
      opacity: 0.7;
      user-select: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .master-detail-toggle:hover {
      opacity: 1;
    }

    /* SC 2.5.8: grow the target, not the box, so the row keeps its height. */
    .master-detail-toggle {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        inset-block-start: 50%;
        inset-inline-start: 50%;
        translate: -50% -50%;
        inline-size: var(--tbw-touch-target-min, 24px);
        block-size: var(--tbw-touch-target-min, 24px);
      }
    }

    @media (pointer: coarse) {
      .master-detail-toggle {
        min-width: var(--tbw-touch-target-min, 24px);
        min-height: var(--tbw-touch-target-min, 24px);
      }
    }

    .master-detail-row {
      grid-column: 1 / -1;
      display: grid;
      background: var(--tbw-master-detail-bg, var(--tbw-color-row-alt));
      border-bottom: 1px solid var(--tbw-master-detail-border, var(--tbw-color-border));
      overflow: hidden;
    }

    .master-detail-cell {
      padding: var(--tbw-detail-padding, var(--tbw-spacing-xl, 1rem));
      overflow: auto;
    }

    /* Animation for expanding detail rows */
    .master-detail-row.tbw-expanding {
      animation: tbw-detail-expand var(--tbw-animation-duration, 200ms) var(--tbw-animation-easing, ease-out) forwards;
    }

    /* Animation for collapsing detail rows */
    .master-detail-row.tbw-collapsing {
      animation: tbw-detail-collapse var(--tbw-animation-duration, 200ms) var(--tbw-animation-easing, ease-out) forwards;
    }
  }

  @keyframes tbw-detail-expand {
    from {
      opacity: 0;
      max-height: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
    to {
      opacity: 1;
      max-height: var(--tbw-detail-max-height, 31.25rem);
      padding-top: var(--tbw-detail-padding, var(--tbw-spacing-xl, 1rem));
      padding-bottom: var(--tbw-detail-padding, var(--tbw-spacing-xl, 1rem));
    }
  }

  @keyframes tbw-detail-collapse {
    from {
      opacity: 1;
      max-height: var(--tbw-detail-max-height, 31.25rem);
    }
    to {
      opacity: 0;
      max-height: 0;
    }
  }
} /* End @layer tbw-plugins */
